import styled from 'styled-components';

export const Card = styled.div`
  flex: 1;
  display: flex;
  border: 1px solid #e5e5e5;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #d5d5d5;
  border-radius: 5px;
  align-items: stretch;
  align-content: stretch;
`;

export const Items = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;

  & th, tr:not(:last-child) {
    border-bottom: 1px solid #ddd !important;
  }
`;

export const Options = styled.div`
  padding: 10px;
  border-left: 1px solid #ddd;
  display: flex;
  align-items: center;
`;

interface ITableHeaderTitleProps {
  width?: string;
}

export const TableHeaderCell = styled.th<ITableHeaderTitleProps>`
  font-weight: bold;
  width: ${props => props.width || 'auto'};
`;